import type { ReactNode } from 'react';

interface KPICardProps {
  label: string;
  value: string;
  trend?: number;
  accentColor?: string;
  delay?: number;
}

export function KPICard({ label, value, trend, accentColor, delay = 0 }: KPICardProps) {
  return (
    <div
      className="fade-up"
      style={{
        background: 'var(--bg-elevated)',
        border: '1px solid var(--border-subtle)',
        borderRadius: '12px',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        animationDelay: `${delay}s`,
        borderLeft: accentColor ? `3px solid ${accentColor}` : '1px solid var(--border-subtle)',
      }}
    >
      <div style={{
        fontSize: '11px',
        fontWeight: 600,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        color: 'var(--text-secondary)',
        fontFamily: 'var(--font-sans)',
      }}>
        {label}
      </div>
      <div style={{
        fontSize: '28px',
        fontWeight: 600,
        color: 'var(--text-primary)',
        fontFamily: 'var(--font-mono)',
        letterSpacing: '-0.02em',
        lineHeight: 1,
      }}>
        {value}
      </div>
      {trend !== undefined && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '4px',
          fontSize: '12px',
          fontFamily: 'var(--font-mono)',
          color: trend >= 0 ? 'var(--green)' : 'var(--red)',
        }}>
          {trend >= 0 ? '↑' : '↓'} {Math.abs(trend).toFixed(1)}%
        </div>
      )}
    </div>
  );
}

interface KPIGridProps {
  children: ReactNode;
  columns?: number;
}

export function KPIGrid({ children, columns = 4 }: KPIGridProps) {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: `repeat(${columns}, 1fr)`,
      gap: '16px',
    }}>
      {children}
    </div>
  );
}
